import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import partial from 'lodash/partial';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import {formDataManager} from 'hoc/formDataManager';
import {createResourceAction} from 'resources/actions';
import {resourcesSelector} from 'resources/selectors';
import * as ResourceApi from 'api/resources';
import AddStepsModal from './AddStepsModal';
import {endAddStepsAction} from '../actions';
import config from './addStepFormConfig';

const mapStateToProps = state => {
  const { addingSteps: modalOpen, currentPlatform } = state.viewAllPlatforms;
  const challenge = get(state.editBreak, 'break', null);

  if (isEmpty(challenge)) {
    return {
      modalOpen,
      currentPlatform,
      resourceId: null
    };
  } else {
    const resources = resourcesSelector(state.resources);
    const breakId = challenge[currentPlatform];
    const rootResource = get(resources, breakId, {});

    return {
      modalOpen,
      currentPlatform,
      rootResource
    };
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  addSteps: (rootResource, data) => createResourceAction(ResourceApi.Types.BreakStep, {
    stepTypes: data.stepTypesToAdd
  }, rootResource, [rootResource.resourceId], [], ['steps.0']),
  handleCloseForCurrentPlatform: endAddStepsAction
}, dispatch);

const AddStepsModalConnected = connect(mapStateToProps, mapDispatchToProps);

const AddStepsModalWithHandlers = withHandlers({
  onSaveData: props => partial(props.addSteps, props.rootResource),
  handleClose: props => partial(props.handleCloseForCurrentPlatform, props.currentPlatform)
});

const AddStepsModalResourceForm = formDataManager({
  stepTypesToAdd: []
}, config);

const AddStepsModalLifecycle = lifecycle({
  componentWillReceiveProps(nextProps) {
    const modalWillClose = this.props.modalOpen && !nextProps.modalOpen;
    if (modalWillClose) {
      this.props.reset();
    }
  }
});

const AddStepsModalContainer = compose(
  AddStepsModalConnected,
  AddStepsModalWithHandlers,
  AddStepsModalResourceForm,
  AddStepsModalLifecycle
)(AddStepsModal);

export default AddStepsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/AddSteps/AddStepsModalContainer.js